import work1 from '../images/content_image/PF_main-visual.png';
import work2 from '../images/content_image/pf_about.png';
import work3 from '../images/content_image/sticky_logo.png';
import work4 from '../images/content_image/town.png';
import work5 from '../images/content_image/fashion_design1.png';
import work6 from '../images/content_image/fashion_design2.png';
import work7 from '../images/content_image/fashion_design3.png';
import work8 from '../images/content_image/DSC_0112.png';
import work9 from '../images/content_image/DSC_0113.png';
import work10 from '../images/content_image/twitter_clone.png';
import work11 from '../images/content_image/hanaki_web.png';

export const WorkList = [
  {
    image: work5,
    url: '',
    projectName: ''
  },
  {
    image: work6,
    url: '',
    projectName: ''
  },
  {
    image: work7,
    url: '',
    projectName: ''
  },
  {
    image: work8,
    url: '',
    projectName: ''
  },
  {
    image: work9,
    url: '',
    projectName: ''
  },
  {
    image: work1,
    url: '',
    projectName: ''
  },
  {
    image: work2,
    url: '',
    projectName: ''
  },
  {
    image: work3,
    url: '',
    projectName: ''
  },
  {
    image: work4,
    url: '',
    projectName: ''
  },
  {
    image: work10,
    url: 'https://twitter-copy-practice.vercel.app/',
    projectName: 'twitter clone practice'
  },
  {
    image: work11,
    url: 'https://github.com/P1zza-L1cht',
    projectName: 'Vtuber 花木リン サイト（作成中）'
  },
];